import React, { Component } from 'react';
import PropTypes from 'prop-types';
import strings from '../../../strings';

export default class Label extends Component {
    static propTypes = { s: PropTypes.string.isRequired };

    render() {
        return (
            <div className="text-xs text-uppercase text-mute m-t-xs">
                {strings[this.props.s]}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/Cart/DurationInput/Label.jsx